import React from 'react';
import { t } from 'src/viewLayer/helpers/translations';
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import { useEmailPagePath } from 'src/viewLayer/navigation';
import safeLocalStorage from 'src/viewLayer/helpers/safeLocalStorage';
import './index.scss';

export default () => {
  const { devicePath } = useAppConfigContext();

  if (devicePath !== 'login') return null;

  return (
    <TrackableLink
      className="hint-link"
      data-testid="change-email-link"
      spaHREF={ useEmailPagePath() }
      onClick={ () => safeLocalStorage.remove('email') }
      trackingId={'change_email_link'}>
      { t('password.links.change_email_question') }
      <span>
          { t('password.links.change_email_action') }
      </span>
    </TrackableLink>
  );
};
